import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M19.5 2.5H4.5a2 2 0 00-2 2v15a2 2 0 002 2h15a2 2 0 002-2V4.5a2 2 0 00-2-2z" }),
    React.createElement("path", { d: "M6 11h12v2H6z", fill: "currentColor", stroke: "transparent" })));
export default createSvgIcon(iconPath, "CheckboxIndeterminate");
//# sourceMappingURL=CheckboxIndeterminateIcon.js.map